import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
} from "reactstrap";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import useAxios from "../../../sections/useAxios";
import { companySchema } from "../../../validations/validation-schemas";

const CompanyEditForm = ({ isOpen, toggle, company, refetch }) => {
  const api = useAxios();

  const updateMutation = useMutation(
    async (values) => {
      return api.patch(`company/update-company/${company.id}`, values);
    },
    {
      onSuccess: () => {
        toast.success("Company updated successfully");
        refetch();
        toggle();
      },
      onError: (error) => {
        toast.error(error?.response?.data?.message);
      },
    }
  );

  const formik = useFormik({
    initialValues: {
      name: company?.name || "",
      email: company?.email || "",
      location: company?.location || "",
      participants: company?.participants || "",
    },
    enableReinitialize: true,
    validationSchema: companySchema,
    onSubmit: (values) => {
      updateMutation.mutate(values);
    },
  });

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Edit Company</ModalHeader>
      <ModalBody>
        <Form onSubmit={formik.handleSubmit}>
          <FormGroup>
            <Label for="name">Name</Label>
            <Input
              id="name"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.name && !!formik.errors.name}
            />
            {formik.touched.name && formik.errors.name && (
              <div className="invalid-feedback d-block">
                {formik.errors.name}
              </div>
            )}
          </FormGroup>

          <FormGroup>
            <Label for="email">Email</Label>
            <Input
              id="email"
              name="email"
              type="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.email && !!formik.errors.email}
            />
            {formik.touched.email && formik.errors.email && (
              <div className="invalid-feedback d-block">
                {formik.errors.email}
              </div>
            )}
          </FormGroup>

          <FormGroup>
            <Label for="location">Location</Label>
            <Input
              id="location"
              name="location"
              value={formik.values.location}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.location && !!formik.errors.location}
            />
            {formik.touched.location && formik.errors.location && (
              <div className="invalid-feedback d-block">
                {formik.errors.location}
              </div>
            )}
          </FormGroup>

          <FormGroup>
            <Label for="participants">Allowed Investors</Label>
            <Input
              id="participants"
              name="participants"
              value={formik.values.participants}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.participants && !!formik.errors.participants}
              type="number"
              min={1}
            />
            {formik.touched.participants && formik.errors.participants && (
              <div className="invalid-feedback d-block">
                {formik.errors.participants}
              </div>
            )}
          </FormGroup>

          <Button
            type="submit"
            className="primary-bg text-white primary-hover"
            disabled={updateMutation.isLoading}
          >
            {updateMutation.isLoading ? <Spinner size="sm" /> : "Update"}
          </Button>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default CompanyEditForm;
